import { render, staticRenderFns } from "./factory-sel-page.vue?vue&type=template&id=2c40f424&scoped=true"
import script from "./factory-sel-page.vue?vue&type=script&lang=js"
export * from "./factory-sel-page.vue?vue&type=script&lang=js"
import style0 from "./factory-sel-page.vue?vue&type=style&index=0&id=2c40f424&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c40f424",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c40f424')) {
      api.createRecord('2c40f424', component.options)
    } else {
      api.reload('2c40f424', component.options)
    }
    module.hot.accept("./factory-sel-page.vue?vue&type=template&id=2c40f424&scoped=true", function () {
      api.rerender('2c40f424', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/base-data/factory-sel-page.vue"
export default component.exports